export enum ModalDismissStatus {
    Cancel = 'Cancel',
    Delete = 'Delete'
}
